import { Pipe, PipeTransform } from '@angular/core';
import { ServiceProvider } from '../providers/services';

@Pipe({name: 'serviceData'})
export class ServiceDataPipe implements PipeTransform {
  constructor(private serviceProvider: ServiceProvider) {}
  transform(value: any): any {
    return this.serviceProvider.getServiceById(value);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/service-data.pipe.ts